import React from 'react'
import styles from '../styles.module.css'
import Modal from '../../../../components/Modal'
import { Input, Select } from '../../../../components/ModalInputs'
import ModalFooter from '../../../../components/ModalFooter/ModalFooter'
import { useFormik } from 'formik'
import { DAY_NAMES } from './Exceptions'

export default function ModalExceptions({ open, data, closeModal, groups, onSave }) {

  const {
    values,
    errors,
    touched,
    submitCount,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: data ? {
      starttime: data.starttime,
      stoptime: data.stoptime,
      type: data.type || '',
      date: data.date || '',
      day_of_week: data.day_of_week ?? '',
      gid: data.gid || '',
    } : {
      starttime: '08:00',
      stoptime: '08:45',
      type: '',
      date: '',
      day_of_week: '',
      gid: '',
    },
    enableReinitialize: true,
    validate: (vals) => {
      const errs = {}
      if (!vals.type) errs.type = 'Выберите тип'
      if (vals.starttime && vals.stoptime && vals.starttime > vals.stoptime) {
        errs.stoptime = 'Время начала не может быть больше времени окончания'
      }
      if (vals.type === 'date' && !vals.date) errs.date = 'Выберите дату'
      if (vals.type === 'dow' && vals.day_of_week === '') errs.day_of_week = 'Выберите день недели'
      if (vals.type === 'class' && !vals.gid) errs.gid = 'Выберите класс'
      return errs
    },
    onSubmit: (vals) => {
      onSave({
        starttime: vals.starttime,
        stoptime: vals.stoptime,
        type: vals.type,
        date: vals.type === 'date' ? vals.date : undefined,
        day_of_week: vals.type === 'dow' ? Number(vals.day_of_week) : undefined,
        gid: vals.type === 'class' ? vals.gid : undefined,
      })
    }
  })

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

  const handleTypeChange = (e) => {
    handleChange(e)
    const { value } = e.target
    if (value !== 'date') setFieldValue('date', '')
    if (value !== 'dow') setFieldValue('day_of_week', '')
    if (value !== 'class') setFieldValue('gid', '')
  }

  return (
    <Modal open={open} width={'600px'}>
      <div className={styles.modalMain}>
        <div className={styles.tabWrapper}>
          <div className={styles.inputsRow}>
            <Input
              label='Начало'
              name='starttime'
              type='time'
              value={values.starttime}
              onChange={handleChange}
            />
            <Input
              label='Окончание'
              name='stoptime'
              type='time'
              value={values.stoptime}
              error={error('stoptime')}
              onChange={handleChange}
            />
          </div>
          <div className={styles.inputsRow}>
            <Select
              label='Тип'
              name='type'
              value={values.type}
              error={error('type')}
              onChange={handleTypeChange}
            >
              <option value=''>— выберите —</option>
              <option value='date'>По дате</option>
              <option value='dow'>По дню недели</option>
              <option value='class'>Для класса</option>
            </Select>
          </div>
          <div className={styles.inputsRow}>
            <Input
              label='Дата'
              name='date'
              type='date'
              value={values.date}
              error={error('date')}
              onChange={handleChange}
              disabled={values.type !== 'date'}
            />
          </div>
          <div className={styles.inputsRow}>
            <Select
              label='День недели'
              name='day_of_week'
              value={values.day_of_week}
              error={error('day_of_week')}
              onChange={handleChange}
              disabled={values.type !== 'dow'}
            >
              <option value=''>— выберите —</option>
              {DAY_NAMES.map((d, i) => <option key={d} value={i}>{d}</option>)}
            </Select>
          </div>
          <div className={styles.inputsRow}>
            <Select
              label='Класс'
              name='gid'
              value={values.gid}
              error={error('gid')}
              onChange={handleChange}
              disabled={values.type !== 'class'}
            >
              <option value=''>— выберите —</option>
              {groups?.map(c => <option key={c.gid} value={c.gid}>{c.name}</option>)}
            </Select>
          </div>
        </div>
      </div>
      <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
    </Modal>
  )
}
